import { render, staticRenderFns } from "./SamplesIndex.vue?vue&type=template&id=5e36e6a9"
import script from "./SamplesIndex.vue?vue&type=script&lang=js"
export * from "./SamplesIndex.vue?vue&type=script&lang=js"
import style0 from "./SamplesIndex.vue?vue&type=style&index=0&id=5e36e6a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports